import classNames from "classnames";
import { ArrowLink } from "../../../../../common/components/Link";
import { URL_CONTACT_US } from "../../../../../utils/url/staticUrls";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
}

const NotFoundContactUsBar = (props: Props) => {
  const { t } = useTranslation();
  const cls = classNames("scha__not-found-contact-us", props.className);

  return (
    <div className={cls}>
      <span className="scha__not-found-contact-us__text">{t("notFoundContactUs.question")}</span>
      <ArrowLink href={URL_CONTACT_US}>{t("notFoundContactUs.contact")}</ArrowLink>
    </div>
  );
};

export default NotFoundContactUsBar;
